import { FC, useMemo } from 'react';

import { AlertTooltip } from '@payaca/components/iconTooltip/IconTooltip';
import Tooltip from '@payaca/components/tooltip/Tooltip';
import { ListedDeal } from '@payaca/types/listedDealTypes';

import UntitledIcon from '@payaca/untitled-icons';
import './ListedDealInfoIcons.sass';

type Props = {
  listedDeal: ListedDeal;
};
const ListedDealInfoIcons: FC<Props> = ({ listedDeal }: Props) => {
  const issue = useMemo(() => {
    if (listedDeal.isAnyBounced) {
      return 'E-mail has bounced';
    } else if (listedDeal.isAnyOverdue) {
      return 'Invoice payment is overdue';
    }
  }, [listedDeal]);
  return (
    <div className="listed-deal-info-icons text-blue-900">
      {listedDeal.isAllViewed && (
        <Tooltip text={'Viewed by customer'}>
          <UntitledIcon name="eye.3" />
        </Tooltip>
      )}

      {issue && (
        <div className={'card-issue'}>
          <AlertTooltip tooltipText={issue} />
        </div>
      )}
    </div>
  );
};

export default ListedDealInfoIcons;
